// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vant from 'vant'
import './style/common.less'
import '@/utils/rem.js'
import 'vant/lib/index.css'
import { setTitle } from '@/utils/setTitle'
import VueClipboard from 'vue-clipboard2'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// import VConsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new VConsole()
// console.log(vConsole)
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(mavonEditor)
Vue.use(VueClipboard)
/* eslint-disable no-new */
router.beforeEach((from, to, next) => {
  console.log(from, to)
  // store.commit('updataActiveIndex', from.query.from)
  // let domain = location.href.split('#')[0]
  // if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) && domain !== 'http://localhost:8090/') {
  //   window.location.href = process.env.JUMP_URL
  // }
  if (from.meta.title) {
    setTitle(from.meta.title)
  }
  next()
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js